import { gql } from '@/apollo'

export const GET_APPOINTMENT_DETAILS = gql`
  query GetAppointmentDetails {
    appointmentDetails {
      id
      name
      canCancel
      canReschedule
      canSchedule
      customerId
      customer {
        id
        name
        description
      }
      createdAt
      updatedAt
      notes {
        id
        content
        order
      }
    }
  }
`

export const CREATE_APPOINTMENT_DETAIL = gql`
  mutation CreateAppointmentDetail($input: CreateAppointmentDetailInput!) {
    createAppointmentDetail(input: $input) {
      id
      name
      canCancel
      canReschedule
      canSchedule
      customerId
      customer {
        id
        name
        description
      }
      notes { id content order }
    }
  }
`

export const UPDATE_APPOINTMENT_DETAIL = gql`
  mutation UpdateAppointmentDetail($id: ID!, $input: UpdateAppointmentDetailInput!) {
    updateAppointmentDetail(id: $id, input: $input) {
      id
      name
      canCancel
      canReschedule
      canSchedule
      customerId
      customer {
        id
        name
        description
      }
      notes { id content order }
    }
  }
`

export const DELETE_APPOINTMENT_DETAIL = gql`
  mutation DeleteAppointmentDetail($id: ID!) {
    deleteAppointmentDetail(id: $id)
  }
`


